<ng-template #cdtHeaderTemplate>
  <fa-icon [icon]="['far', 'clock']" size="2x" class="text-primary transparent-3"></fa-icon>
</ng-template>
<ng-template #cdtTemplateContent>
  <div class="cdt-content p-3 d-flex flex-column">
    @if (cdt$ | async; as cdt) {
      <div class="mb-4">
        @if (cdt.total === 0) {
          <div>
            Vous n'avez pas de carnet de temps
          </div>
        }
        @if (cdt.total > 0) {
          <div class="fw-bold">{{ cdt.reste | hours }} restante(s) sur le carnet de temps</div>
        }
      </div>
    }
    <a href="#" class="align-self-end" (click)="showCdt = true">Gérer mon carnet de temps</a>
    <app-cdt-infos [(show)]="showCdt"></app-cdt-infos>
  </div>
</ng-template>
<app-dash-block title="Carnet de temps" [headerTemplate]="cdtHeaderTemplate"
  [contentTemplate]="(cdt$ | async) ? cdtTemplateContent : null">
</app-dash-block>
